// import React from "react";
// import styles from "./styles/ChatInputBox.module.css";
// import {
//     ArrowUpTrayIcon,
//     LinkIcon,
//     ClipboardDocumentListIcon,
// } from "@heroicons/react/24/outline";

// function SourcesInputBox() {
//     return (
//         <div className={styles.wrapper}>
//             <div
//                 className={styles.box}
//                 style={{
//                     display: "grid",
//                     gridTemplateColumns: "1fr 1fr 1fr",
//                 }}
//             >
//                 <div className={styles.inner_box}>
//                     <div className={styles.inner_box_header}>
//                         <LinkIcon />
//                         <span>Links</span>
//                     </div>
//                     <p>Link of alicebluerticle, website, YouTube etc</p>
//                 </div>
//                 <div
//                     className={styles.inner_box}
//                     style={{
//                         borderRight: "1px solid #ddd",
//                         borderLeft: "1px solid #ddd",
//                     }}
//                 >
//                     <div className={styles.inner_box_header}>
//                         <ArrowUpTrayIcon />
//                         <span>Upload</span>
//                     </div>
//                     <p>Upload document, image, pdf etc</p>
//                 </div>
//                 <div className={styles.inner_box}>
//                     <div className={styles.inner_box_header}>
//                         <ClipboardDocumentListIcon />
//                         <span>Paste</span>
//                     </div>
//                     <p>Paste text</p>
//                 </div>
//             </div>
//         </div>
//     );
// }

// export default SourcesInputBox;
import {
    BulbOutlined,
    FileExcelOutlined,
    FileImageOutlined,
    FileMarkdownOutlined,
    FileOutlined,
    FilePdfOutlined,
    FileTextOutlined,
    FileWordOutlined,
    FileZipOutlined,
    RiseOutlined,
} from "@ant-design/icons";
import {
    ArrowUpTrayIcon,
    ClipboardDocumentListIcon,
    LinkIcon,
} from "@heroicons/react/24/outline";
import { Card, Empty, Input, Typography } from "antd";
import log from "cslog";
import React, { useRef, useState } from "react";
import { useItemsFine } from "../_actions/app/items";
import { history } from "../_helpers/history";
import CreationFromLinkBox, {
    GeneratedIdeasBox,
} from "../content_calender_new/CreationFromLinkBox";
import styles from "./styles/ChatInputBox.module.css";

const { TextArea } = Input;
const { Text, Title, Paragraph } = Typography;

function SourcesInputBox({
    me,
    isMobile,
    enable_tabs = ["link", "document", "text", "trends"],
    show_history = true,
}) {
    const [activeModal, setActiveModal] = useState(null);
    const [linkInput, setLinkInput] = useState("");
    const [textInput, setTextInput] = useState("");
    const [file, setFile] = useState(null);
    const creationLinkBoxRef = useRef();

    const getFileIcon = (fileName) => {
        if (!fileName) return FileOutlined;

        const extension = fileName.split(".").pop().toLowerCase();

        switch (extension) {
            case "pdf":
                return FilePdfOutlined;
            case "doc":
            case "docx":
                return FileWordOutlined;
            case "xls":
            case "xlsx":
            case "csv":
                return FileExcelOutlined;
            case "txt":
            case "rtf":
                return FileTextOutlined;
            case "md":
            case "markdown":
                return FileMarkdownOutlined;
            case "jpg":
            case "jpeg":
            case "png":
            case "gif":
            case "bmp":
            case "svg":
            case "webp":
            case "ico":
                return FileImageOutlined;
            case "zip":
            case "rar":
            case "7z":
            case "tar":
            case "gz":
                return FileZipOutlined;
            default:
                return FileOutlined;
        }
    };

    const handleSubmit = (type) => {
        switch (type) {
            case "link":
                console.log("Link submitted:", linkInput);
                setLinkInput("");
                break;
            case "document":
                console.log("File submitted:", file?.name);
                setFile(null);
                break;
            case "text":
                console.log("Text submitted:", textInput);
                setTextInput("");
                break;
            default:
                break;
        }
        setActiveModal(null);
    };

    const handleUpload = ({ file }) => {
        console.log("File uploaded:", file);
        setFile(file);
    };

    const removeFile = () => {
        setFile(null);
    };

    const tabs = [
        {
            id: "link",
            icon: LinkIcon,
            label: "Links",
            description: "Link of article, website, blog or YouTube etc",
        },
        {
            id: "document",
            icon: ArrowUpTrayIcon,
            label: "Upload",
            description: "Upload document, image, pdf etc",
        },
        {
            id: "text",
            icon: ClipboardDocumentListIcon,
            label: "Write",
            description: "Write text",
        },
        {
            id: "trends",
            icon: RiseOutlined,
            label: "Trends",
            description: "Generate content from latest trends",
        },
    ].filter((tab) => enable_tabs.includes(tab.id));

    return (
        <>
            <div className={styles.wrapper2}>
                {/* Source Options Grid */}
                {/* <div className={styles.sourceTopHeader}>Choose your Source</div> */}
                <div className={styles.sourceGrid}>
                    {tabs.map((tab, index) => {
                        const Icon = tab.icon;

                        return (
                            <div
                                key={tab.id}
                                onClick={() => {
                                    if (tab.id === "trends") {
                                        // alert("showing trends");
                                        history.push("/creatives/trends");
                                    } else {
                                        if (
                                            creationLinkBoxRef.current &&
                                            creationLinkBoxRef.current.open
                                        ) {
                                            creationLinkBoxRef.current.open(
                                                tab.id
                                            );
                                        }
                                    }
                                }}
                                className={`${styles.sourceCard} ${
                                    index === 1 ? styles.sourceCardMiddle : ""
                                }`}
                            >
                                <div className={styles.sourceHeader}>
                                    <Icon className={styles.sourceIcon} />
                                    <span className={styles.sourceLabel}>
                                        {tab.label}
                                    </span>
                                </div>
                                <p className={styles.sourceDescription}>
                                    {tab.description}
                                </p>
                            </div>
                        );
                    })}
                </div>

                {/* Modal for Input */}
                {/* <Modal
                    open={activeModal !== null}
                    onCancel={() => setActiveModal(null)}
                    footer={null}
                    width={500}
                    centered
                    className={styles.sourceModal}
                >
                    {renderModalContent()}
                </Modal> */}
                <CreationFromLinkBox ref={creationLinkBoxRef} me={me} />
            </div>
            {show_history && <SourceHistory me={me} isMobile={isMobile} />}
        </>
    );
}

export default SourcesInputBox;

function SourceHistory({ me, isMobile }) {
    const [selectedSource, setSelectedSource] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);

    const {
        data: historyData = [],
        isLoading: historyLoaidng,
        isSuccess: historySuccess,
    } = useItemsFine(
        "qdb_data_source",
        `fields=*&filter[organization][_eq]=${me?.selected_org.id}`
    );

    const fileIds = React.useMemo(() => {
        return historyData
            ? historyData
                  .filter((source) => source.input_file)
                  .map((source) => source.input_file)
            : [];
    }, [historyData]);

    // useEffect(() => {
    //     const loadFiles = async () => {
    //         if (!file_ids.length) return;

    //         // For each file ID, fetch the data and add to state
    //         const filesObj = {};
    //         for (const id of file_ids) {
    //             try {
    //                 const { file_data, file_success, file_loading } =
    //                     useSingleItem(
    //                         "directus_files",
    //                         `/${id}?fields=*,organization.*`,
    //                         !!id
    //                     );

    //                 filesObj[id] = file_data;
    //             } catch (error) {
    //                 console.error(`Error fetching file ${id}:`, error);
    //             }
    //         }
    //         setFilesData(filesObj);
    //     };

    //     loadFiles();
    // }, [file_ids]);
    // const filesData = useFilesData(fileIds);
    console.log("history data", historyData);
    console.log("me in history", me?.selected_org?.id);
    // console.log("filedata ", filesData);
    const getSourceIcon = (type, inputFile = null) => {
        switch (type) {
            case "link":
                return (
                    <LinkIcon
                        className={styles.sourceTypeIcon}
                        style={{ width: "18px", height: "18px" }}
                    />
                );
            case "document":
                if (inputFile) {
                    const fileType = inputFile.split(".").pop().toLowerCase();

                    switch (fileType) {
                        case "pdf":
                            return (
                                <FilePdfOutlined
                                    className={styles.sourceTypeIcon}
                                    style={{ color: "#ff4d4f" }}
                                />
                            );
                        case "doc":
                        case "docx":
                            return (
                                <FileWordOutlined
                                    className={styles.sourceTypeIcon}
                                    style={{ color: "#1890ff" }}
                                />
                            );
                        case "jpg":
                        case "png":
                        case "gif":
                            return (
                                <FileImageOutlined
                                    className={styles.sourceTypeIcon}
                                    style={{ color: "#722ed1" }}
                                />
                            );
                        default:
                            return (
                                <FileTextOutlined
                                    className={styles.sourceTypeIcon}
                                />
                            );
                    }
                }
                return <ArrowUpTrayIcon className={styles.sourceTypeIcon} />;
            case "text":
                return (
                    <ClipboardDocumentListIcon
                        className={styles.sourceTypeIcon}
                    />
                );
            default:
                return <FileTextOutlined className={styles.sourceTypeIcon} />;
        }
    };

    const getSourceTypeLabel = (type) => {
        switch (type) {
            case "link":
                return "Link";
            case "document":
                return "File Uploaded";
            case "text":
                return "Text Input";
            case "trends":
                return "Trends";
            default:
                return "Unknown";
        }
    };

    const formatDate = (timestamp) => {
        return new Date(timestamp).toLocaleDateString("en-US", {
            year: "numeric",
            month: "short",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
        });
    };

    const handleCardClick = (source) => {
        setSelectedSource(source);
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
        setSelectedSource(null);
    };

    return (
        <div className={styles.historyContainer}>
            <div className={styles.historyHeader}>
                <Title level={4} className={styles.historyTitle}>
                    SOURCE HISTORY
                </Title>
                <Text type="secondary" style={{ marginTop: "-20px" }}>
                    View your previous sources and generated ideas
                </Text>
            </div>

            {historyData.length === 0 ? (
                <Empty
                    description="No source history found"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                />
            ) : (
                <div className={styles.historyGrid}>
                    {historyData.map((source, index) => (
                        <SourceHistoryCard
                            key={index}
                            source={source}
                            getSourceIcon={getSourceIcon}
                            handleCardClick={handleCardClick}
                            isMobile={isMobile}
                        />
                        // <Card
                        //     key={source.id}
                        //     className={styles.historyCard}
                        //     hoverable
                        //     onClick={() => handleCardClick(source)}
                        // >
                        //     <div className={styles.cardHeader}>
                        //         <div className={styles.sourceType}>
                        //             {getSourceIcon(
                        //                 source.type,
                        //                 source.input_file
                        //             )}
                        //             <Tag>{source.type.toUpperCase()}</Tag>
                        //         </div>
                        //         <div className={styles.timestamp}>

                        //             <Text
                        //                 type="secondary"
                        //                 // className={styles.timestampText}
                        //                 className={styles.ideasHeader}
                        //             >
                        //                 {/* {formatDate(source.date_created)} */}
                        //                 <BulbOutlined />

                        //                 {
                        //                     (source.generated_ideas || [])
                        //                         .length
                        //                 }{" "}
                        //                 Ideas Generated

                        //             </Text>
                        //         </div>
                        //     </div>

                        //     <div className={styles.cardContent}>
                        //         {/* <Title level={5} className={styles.sourceTitle}>
                        //             {source.title}
                        //         </Title> */}

                        //         <div className={styles.inputData}>
                        //             <Text className={styles.inputLabel}>
                        //                 {source.type === "link"
                        //                     ? "URL:"
                        //                     : source.type === "document"
                        //                         ? "File:"
                        //                         : "Input:"}
                        //             </Text>
                        //             <Paragraph className={styles.inputText}>
                        //                 {source.type === "link" ? (
                        //                     <a
                        //                         href={source.input_data}
                        //                         target="_blank"
                        //                         rel="noopener noreferrer"
                        //                         onClick={(e) =>
                        //                             e.stopPropagation()
                        //                         }
                        //                         className={styles.cardLinkText}
                        //                     >
                        //                         {truncateText(
                        //                             source.input_data
                        //                         )}
                        //                     </a>
                        //                 ) : source.type === "document" ? (
                        //                     <span
                        //                         className={styles.fileNameText}
                        //                     >
                        //                         {truncateText(
                        //                             source.input_file
                        //                         )}
                        //                     </span>
                        //                 ) : (
                        //                     truncateText(source.input_data)
                        //                 )}
                        //             </Paragraph>
                        //         </div>

                        //         <div className={styles.ideasPreview}>
                        //             <div className={styles.ideasHeader}>
                        //                 <BulbOutlined />
                        //                 <Text strong>
                        //                     {
                        //                         (source.generated_ideas || [])
                        //                             .length
                        //                     }{" "}
                        //                     Ideas Generated
                        //                 </Text>
                        //             </div>
                        //             <Button type="link" icon={<EyeOutlined />}>
                        //                 View Ideas
                        //             </Button>
                        //         </div>
                        //     </div>
                        // </Card>
                    ))}
                </div>
            )}

            <GeneratedIdeasBox
                open={isModalOpen}
                setOpen={setIsModalOpen}
                result={{
                    success: true,
                    ...selectedSource,
                }}
                me={me}
                generation_type="normal"
            />

            {/* Ideas Modal */}
            {/* <Modal
                title={
                    <div className={styles.modalHeader}>
                        {selectedSource &&
                            getSourceIcon(
                                selectedSource.type,
                                selectedSource.input_file
                            )}
                    </div>
                }
                // open={isModalOpen}
                open={false}
                onCancel={handleModalClose}
                footer={null}
                width={700}
                className={styles.ideasModal}
            >
                {selectedSource && (
                    <div className={styles.modalContent}>
                        <div className={styles.sourceDetails}>
                            <div className={styles.sourceInfo}>
                                <Tag>
                                    {getSourceTypeLabel(selectedSource.type)}
                                </Tag>
                                <Text type="secondary">
                                    {formatDate(selectedSource.date_created)}
                                </Text>
                            </div>

                            <div className={styles.originalInput}>
                                <Text strong className={styles.sectionLabel}>
                                    Original Input:
                                </Text>
                                <div className={styles.inputContent}>
                                    {selectedSource.type === "link" ? (
                                        <a
                                            href={selectedSource.input_data}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            className={styles.linkInput}
                                        >
                                            {selectedSource.input_data}
                                        </a>
                                    ) : (
                                        <Paragraph className={styles.textInput}>
                                            {selectedSource.input_data}
                                        </Paragraph>
                                    )}
                                </div>
                            </div>
                        </div>

                        <div className={styles.generatedIdeas}>
                            <Title level={4} className={styles.ideasTitle}>
                                <BulbOutlined
                                    className={styles.ideasTitleIcon}
                                />
                                Generated Ideas
                            </Title>

                            <div className={styles.ideasList}>
                                {selectedSource.generated_ideas &&
                                    selectedSource.generated_ideas.map(
                                        (idea, index) => (
                                            <div
                                                key={index}
                                                className={styles.ideaItem}
                                            >
                                                <div
                                                    className={
                                                        styles.ideaNumber
                                                    }
                                                >
                                                    {index + 1}
                                                </div>
                                                <Text
                                                    className={styles.ideaText}
                                                >
                                                    {idea.idea || idea}
                                                </Text>
                                            </div>
                                        )
                                    )}
                            </div>
                        </div>
                    </div>
                )}
            </Modal> */}
        </div>
    );
}

function truncateText(text, maxLength = 100) {
    if (!text) return "";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
}

function SourceHistoryCard({
    source,
    handleCardClick,
    getSourceIcon,
    isMobile,
}) {
    log.d(source, "Source History Card");
    return (
        <Card
            key={source.id}
            className={styles.historyCard}
            hoverable
            onClick={() => handleCardClick(source)}
            size={isMobile ? "small" : "default"}
        >
            <div className={styles.history_card_header}>
                <div className={styles.icon}>
                    {getSourceIcon(source.type, source.input_file)}
                </div>

                <div className={styles.history_card_header_text}>
                    {source.type === "link" ? (
                        <a
                            href={source.input_data}
                            target="_blank"
                            rel="noopener noreferrer"
                            onClick={(e) => e.stopPropagation()}
                            className={styles.cardLinkText}
                        >
                            {truncateText(source.input_data)}
                        </a>
                    ) : source.type === "document" ? (
                        <span className={styles.fileNameText}>
                            {truncateText(source.input_file)}
                        </span>
                    ) : (
                        truncateText(source.input_data)
                    )}
                </div>

                <Text type="secondary" className={styles.idea_count}>
                    <BulbOutlined />
                    {source?.generated_ideas?.length || 0}
                </Text>
            </div>
            <div className={styles.history_card_content}>
                {source?.extracted_data?.markdown}
                {/* Extracted text this is some demo text you can see this text here. text this is some demo text you can see this text here. text this is some demo text you can see this text here. */}
            </div>
        </Card>
    );
}
